import axios from 'axios'
const main = axios.create()

const requestData = (method, path, data = null, config = {}) => {
  const apiUrl = `https://admin.wecharge.com.br/api/${path}`;
  return main[method](apiUrl, data, config)
    .then(response => response.data)
    .catch(error => {
      if (error.response && error.response.data) {
        return error.response.data
      }
      return { errors: {} }
    })
}

export default requestData